import React, { useState, useCallback } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import { useDropzone } from 'react-dropzone';
import { FaFileUpload } from 'react-icons/fa';

// Renamed component
const UploadPopModal = ({ show, onHide, onSubmit }) => {
  const [popFile, setPopFile] = useState(null);
  const [fileError, setFileError] = useState(null);

  const onDrop = useCallback((acceptedFiles, rejectedFiles) => {
    setFileError(null); // Clear previous errors
    if (rejectedFiles && rejectedFiles.length > 0) {
      const errorMessages = rejectedFiles.map(f => f.errors.map(e => e.message).join(', ')).join('; ');
      setFileError(`File rejected: ${errorMessages}. Please upload a valid PDF or image file.`);
      setPopFile(null);
    } else if (acceptedFiles && acceptedFiles.length > 0) {
      setPopFile(acceptedFiles[0]); // Accept only the first file
    } else {
       setPopFile(null);
    }
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'image/*': ['.jpeg', '.jpg', '.png', '.gif', '.webp'],
      'application/pdf': ['.pdf'],
    },
    multiple: false,
    // Add size limits if needed: maxSize: 5 * 1024 * 1024, // 5MB example
  });

  const handleSubmit = () => {
    if (popFile) {
      onSubmit(popFile); // Pass the file object to the handler
    } else {
      setFileError("Please upload your Proof of Payment file.");
    }
  };

  // Clear file and error when hiding modal
  const handleHide = () => {
    setPopFile(null);
    setFileError(null);
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={handleHide}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header closeButton>
        {/* Updated Title */}
        <Modal.Title>Upload Proof of Payment (POP)</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Removed Instructions */}
        <Form.Group controlId="popUploadModal" className="mb-3">
          <Form.Label className="fw-bold">Select or Drop POP File:</Form.Label>
          <div
            {...getRootProps()}
            className={`dropzone p-4 border rounded text-center ${isDragActive ? 'border-primary' : 'border-dashed'}`}
            style={{ cursor: 'pointer' }}
          >
            <input {...getInputProps()} />
            {isDragActive ? (
              <p>Drop the file here ...</p>
            ) : (
              <p>Drag 'n' drop your POP file here (PDF or Image), or click to select file</p>
            )}
            <FaFileUpload size={30} className="text-muted mb-2" />
          </div>
          {popFile && (
            <Alert variant="info" className="mt-2 py-1 px-2 small d-flex justify-content-between align-items-center">
              Selected: {popFile.name}
              <Button variant="link" size="sm" className="p-0 text-danger" onClick={() => setPopFile(null)}>Clear</Button>
            </Alert>
          )}
           {fileError && (
             <Alert variant="danger" className="mt-2 py-1 px-2 small">
               {fileError}
             </Alert>
           )}
        </Form.Group>
      </Modal.Body>
      <Modal.Footer className="justify-content-between"> {/* Use justify-content-between */}
        {/* Changed Button Text */}
        <Button variant="secondary" onClick={handleHide}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleSubmit}
          disabled={!popFile}
        >
          <FaFileUpload className="me-2" /> Submit POP
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

// Updated export name
export default UploadPopModal;
